<div class="p-3">
  <h2 mat-dialog-title>Add Type</h2>

  <mat-dialog-content>
    <form [formGroup]="form">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Type Name</mat-label>
        <input matInput type="text" formControlName="name" autocomplete="off">
        <mat-error *ngIf="Name?.errors?.['required']">Type name is required.</mat-error>
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Cancel</button>
    <button mat-raised-button color="primary" (click)="AddTypeList()">Save</button>
  </mat-dialog-actions>
</div>